import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useVisit } from "../hooks";
import { formatDisplayDate } from "../../../helpers/date";
import { visitOutcomeLabel } from "../../../helpers/enum-labels";

type IVisitParams = {
  id: string;
};

export const Visit: React.FC = () => {
  const { id } = useParams<IVisitParams>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, loading } = useVisit(+id!);

  if (loading) return <Loading />;

  const visit = data?.visit?.result;

  return (
    <>
      <Header
        title="Visite"
        subtitle={visit?.customer?.name}
        buttons={[
          {
            actionText: "Modifier",
            bgColor: "indigo",
            textColor: "white",
            link: `/visit/${id}/update`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="section">
          <div className="element">
            <div className="card">
              <CardHeader title="Informations générales" />
              <div className="flex">
                <div className="w-1/2 mr-1">
                  <div className="w-full mt-3">
                    <p className="label">Date de visite</p>
                    <input className="input w-full" value={formatDisplayDate(visit?.visitDate)} disabled />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Résultat</p>
                    <input className="input w-full" value={visitOutcomeLabel(visit?.outcome)} disabled />
                  </div>
                </div>
              </div>
              <div className="flex">
                <div className="w-1/2 mr-1">
                  <div className="w-full mt-3">
                    <p className="label">Client</p>
                    <input className="input w-full" value={visit?.customer?.name} disabled />
                  </div>
                </div>
                <div className="w-1/2 ml-1">
                  <div className="w-full mt-3">
                    <p className="label">Commercial</p>
                    <input
                      className="input w-full"
                      value={visit?.salesRep?.firstname}
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div className="w-full mt-3">
                <p className="label">Date de relance</p>
                <input className="input w-full" value={formatDisplayDate(visit?.followUpDate)} disabled />
              </div>
              <div className="w-full mt-3">
                <p className="label">Compte-rendu</p>
                <textarea className="input w-full" value={visit?.report} disabled rows={4} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
